<template>
  <div class="car-info">
      <div class="page-top">
          <div class="banner">
              <div class="bnr-box">
                  <swiper class="banner_swiper" ref="bannerSwiper" :options="swiperOption">
                      <swiperSlide v-for="item in pageBanners" :key="item">
                          <div v-if="/\.mp4/.test(item)" class="vd-box">
                            <img v-lazy="item + '?x-oss-process=video/snapshot,t_7000,f_jpg,w_0,h_0,m_fast'" class="b-pic"/>
                            <div class="circle-border" @click="showVideoUrl = item" >
                               <i class="iconfont uc-bofang"></i>
                            </div>
                          </div>
                          <img v-else v-lazy="item + '?x-oss-process=image/resize,m_fill,h_360,w_760'" class="b-pic" @click="onShowCarImage"/>
                      </swiperSlide>
                      <div class="swiper-pagination" slot="pagination"></div>
                  </swiper>
                  <div class="bnr-loading">
                    <mt-spinner type="fading-circle" :size="50" color="#26a2ff"></mt-spinner>
                  </div>
              </div>
          </div>
          <div class="cartop mblock">
            <div class="mk-top">
              <h1>{{pageTitle}}</h1>
              <div class="opt">
                <span class="fav">
                  <img v-if="curFocused" src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-focus.png"  @click="onCancelFocusCar" class="icon-focus"/>
                  <img v-else src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-focus.png"  @click="onFocusCar" class="icon-focus focused"/>
                </span>
                <span class="share">
                  <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-share.png" @click="onShareFriends=true" class="icon-share"/>
                </span>
              </div>
            </div>
            <div class="mk-center">
              <div class="fee">
                <span class="sltt">{{carInfo.price | format10Thou}}万 </span>
                <span class="ortt">新车价：</span>
                <span class="ctline">{{carInfo.newCarPrice | format10Thou}}万</span>
                <span class="ct-span">ID: {{id}}</span>
              </div>
              <div class="btn">
                <span class="sp" @click="showAskFee = true">询问低价</span>
              </div>
            </div>
            <div class="mk-btm" @click="showEcoSolution = true">
              <div class="stt">金融方案<i class="rec-tag"></i></div>
              <div class="sdec">首付三成，{{carInfo.price * .3 | format10Thou}}万开回家<i class="iconfont uc-jinru"></i></div>
            </div>
          </div>
      </div>
      <div class="car-baseinfo mblock">
        <div class="mb-title">
          <h3>车辆信息</h3>
          <div class="sub-tt" @click="navigateTo(`/h5/car/carParams?id=${id}&psn=${psn}`)">
            <span class="txt">更多参数配置<i class="iconfont uc-jinru"></i></span>
          </div>
        </div>
        <div class="info-items">
          <ul class="params">
            <li>
              <span class="field">里程</span>
              <span class="value">
                {{carInfo.trip}}公里
              </span>
            </li>
            <li>
              <span class="field">上牌时间</span>
              <span class="value">
                {{carInfo.regDate}}
              </span>
            </li>
            <li>
              <span class="field">变速箱</span>
              <span class="value">
                {{carInfo.gearbox | gearBoxFormat}}
              </span>
            </li>
            <li>
              <span class="field">排量</span>
              <span class="value">
                {{carInfo.power}}{{carInfo.airIntakeType === 1 ? 'T' : 'L'}}
              </span>
            </li>
            <li>
              <span class="field">过户</span>
              <span class="value">
                {{carInfo.transferCnt}}次
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div class="car-detect mblock">
        <div class="mb-title">
          <h3>检测报告</h3>
          <div class="sub-tt" @click="navigateTo(`/h5/car/carDetect?id=${id}&psn=${psn}`)">
            <span class="txt">更多详细数据<i class="iconfont uc-jinru"></i></span>
          </div>
        </div>
        <div class="detect-items">
          <ul class="detects">
            <li>
              <span class="name">车体骨架检查项目</span>
              <span class="status">已检测</span>
            </li>
            <li>
              <span class="name">发动机舱检查</span>
              <span class="status">已检测</span>
            </li>
            <li>
              <span class="name">车身检查</span>
              <span class="status">已检测</span>
            </li>
            <li>
              <span class="name">驾驶舱检查</span>
              <span class="status">已检测</span>
            </li>
            <li>
              <span class="name">底盘检查</span>
              <span class="status">已检测</span>
            </li>
            <li>
              <span class="name">启动检查</span>
              <span class="status">已检测</span>
            </li>
            <li>
              <span class="name">路试检查</span>
              <span class="status">已检测</span>
            </li>
            <li>
              <span class="name">车辆功能性零部件列表</span>
              <span class="status">已检测</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="car-service mblock">
        <div class="mb-title">
          <h3>服务保障</h3>
        </div>
        <div class="service-items">
          <ul class="services">
            <li @click="changeSwiper(0)" :class="serviceTabIndex === 0 ? 'active-step' : ''">
              <div class="iconfont uc-cheliangweixiubaoyang"></div>
              <div class="name">无理由退车</div>
            </li>
            <li @click="changeSwiper(1)" :class="serviceTabIndex === 1 ? 'active-step' : ''">
              <div class="iconfont uc-zhibaoxiaoshou" style="font-size:.68rem; padding:.25rem 0rem"></div>
              <div class="name">质保期</div>
            </li>
           <li @click="changeSwiper(2)" :class="serviceTabIndex === 2 ? 'active-step' : ''">
              <div class="iconfont uc-socialfill"></div>
              <div class="name">158项检测</div>
            </li>
          </ul>
          <div class="serv-pic-swiper">
            <swiper class="service_swiper" ref="serviceSwiper" :options="ServiceSwiperOption">
                <swiperSlide>
                    <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/returned.png" class="srv-pic"/>
                </swiperSlide>
                <swiperSlide>
                    <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/pic-protect.png" class="srv-pic"/>
                </swiperSlide>
                <swiperSlide>
                    <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/pic-detect.png" class="srv-pic"/>
                </swiperSlide>
                <div class="service-swiper-pagination" slot="pagination" style="display:none"></div>
            </swiper>
          </div>
          <div class="pay-con">
            <div class="ppic">
              <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/pay-pic-bg.png" class="pay-bg"/>
            </div>
          </div>
        </div>
      </div>
      <div class="car-box">
          <h2>同类型车推荐</h2>
          <same-level-list />
      </div>
      <div class="btn-info">
        <img src="https://rs-resource.oss-cn-shanghai.aliyuncs.com/mobile/images/group-logo.png" class="gp-logo" />
      </div>
      <div class="quick-btns">
        <ul class="quick-icons">
          <li @click="onShowQRService">
            <div class="icon">
              <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-qa.png" class="qk-icon" />
            </div>
            <div class="name">
              添加咨询
            </div>
          </li>
         <li @click="showAskFee=true">
            <div class="icon">
              <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-askfee.png" class="qk-icon" />
            </div>
            <div class="name">
              询问低价
            </div>
          </li>
         <li @click="showReserve=true">
            <div class="icon">
              <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/tab-icon-reserve.png" class="qk-icon" />
            </div>
            <div class="name">
              预约看车
            </div>
          </li>
          <li @click="openPay">
            <div class="icon">
              <img src="https://rs-resource.oss-cn-shanghai.aliyuncs.com/mobile/images/icons/icon-paylit.png" class="qk-icon" />
            </div>
            <div class="name">
              付意向金
            </div>
          </li>
        </ul>
      </div>
      <!--金融方案弹框-->
    <mt-popup
      v-model="showEcoSolution"
      class="mt-popup"
      position="bottom">
      <div class="popup-container">
        <div class="title">
          <h3>金融方案</h3>
        </div>
        <div class="content">{{carInfo.financePlan}}</div>
        <div class="btn-row">
          <button class="btm-popup-ok" @click="showEcoSolution=false">我已了解</button>
        </div>
      </div>
    </mt-popup>
    <!--添加咨询弹框-->
    <mt-popup
      v-model="showQR"
      class="mt-popup-cener"
      position="center">
      <div class="popup-container">
        <i class="iconfont uc-guanbi" @click="showQR=false"></i>
        <div class="qr-box">
          <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/gx-qrcode.jpeg" />
        </div>
        <div class="qr-desc">
          二手车客服顾问 保存识别<br/> 添加咨询~~
        </div>
      </div>
    </mt-popup>
    <!--预约到店看车弹框-->
    <mt-popup
      v-model="showReserve"
      class="mt-popup"
      position="bottom"
    >
      <div class="popup-container">
        <div class="title">
          <h3>预约到店看车</h3>
        </div>
        <div class="content">
          <div class="form">
            <div class="row">
              <div class="title">姓   名</div>
              <div class="field">
                <input type="text" v-model="shopView.username" placeholder="请输入您的姓名" class="txt-field"/>
              </div>
            </div>
            <div class="row">
              <div class="title">手 机 号</div>
              <div class="field">
                <input type="text" v-model="shopView.mobile" placeholder="请输入您的手机号码" class="txt-field"/>
              </div>
            </div>
            <div class="row">
              <div class="title">预约时间</div>
              <div class="field" @click="openTimePicker">
                <input disabled type="text" v-model="shopView.plantime" placeholder="请输入您的到店时间" class="txt-field"/>
                <i class="iconfont uc-jinru"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-row">
          <button class="btm-popup-ok" @click="onConfirmShopView">确认</button>
        </div>
      </div>
    </mt-popup>
    <!--立即咨询弹框-->
    <mt-popup
      v-model="showAskFee"
      class="mt-popup"
      position="bottom"
    >
      <div class="popup-container">
        <div class="title">
          <h3>立即咨询</h3>
        </div>
        <div class="content">
          <div class="form">
            <div class="row">
              <div class="title">手 机 号</div>
              <div class="field">
                <input type="text" v-model="shopView.mobile" placeholder="请输入您的手机号码" class="txt-field"/>
              </div>
            </div>
            <div class="row">
              <div class="title">咨询内容</div>
              <div class="field">
                <textarea type="text" v-model="shopView.msg" placeholder="请输入咨询内容" class="txt-area"/>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-row">
          <button class="btm-popup-ok" @click="onConfirmAskFee">确认</button>
        </div>
      </div>
    </mt-popup>
    <!--选择预约时间框-->
    <mt-datetime-picker
      ref="picker"
      type="datetime"
      @confirm="confirmReserveTime"
      :start-date="new Date()"
      @touchmove.native.stop.prevent
      year-format="{value}"
      month-format="{value}"
      date-format="{value}"
      hour-format="{value}"
      minute-format="00"
      >
    </mt-datetime-picker>
    <!--分享指引层-->
    <div v-if="onShareFriends" class="share_mask" @click="onShareFriends=false">
        <div class="share_line">
          <span></span>
          <img src="https://assets.rurushishi.com/activies/mfAct/sharelight.png" alt />
        </div>
        <div class="txt1">
          因为
          <span class="txt1_span">分享</span>，所以世界有了光！
        </div>
        <div class="txt2">好东西必须让更多朋友知道</div>
        <img
          class="tray"
          src="https://assets.rurushishi.com/yq-rs-make/components/share_guide3/tray.png"
          alt
        />
    </div>
    <div class="video-player" v-if="showVideoUrl.length > 0" @click="showVideoUrl=''" @touchmove.prevent>
        <div class="v-container">
          <video id="video" 
              width="100%"
              :src="showVideoUrl" 
              autoplay="true"
              @click.stop.prevent="onVideoTap"
              style="object-fit:fill">
          </video>
        </div>
    </div>
  </div>
 </template>
<script>
import { Popup, Indicator } from 'mint-ui'
import { MessageBox, Toast, DatetimePicker, Spinner } from "mint-ui"
import "swiper/dist/css/swiper.css"
import util from "@/utils/utils"
import * as comreq from "@/utils/comreq"
import { mapState, mapMutations } from "vuex"
import { swiper, swiperSlide } from "vue-awesome-swiper"
import Cookies from "js-cookie"
import SameLevelList from '../list/sameLevelList.vue'
import { getCarItemInfo, removeFavorite, getFavorite, createFavorite, createClue, createPay, getPayInfo } from '../../api'
import { navigateTo } from '../../utils'
//import * as wxsdk from '@/utils/wxsdk'
import wx from "weixin-js-sdk"

const gearTypes = ["手动MT", "自动AT", "双离合DSG", "CVT"]
export default {
  components: {
    swiper,
    swiperSlide,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    SameLevelList,
    [Spinner.name]: Spinner
  },
  props: {},
  filters:{
    gearBoxFormat(type){
      return gearTypes[type]
    },
    format10Thou(price){
          if(price){
             return (price / 100 / 10000).toFixed(2) - 0
          }else{
              return ""
          }
      }
  },
  data() {
    return {
      isPaid: false, //意向金支付
      showVideoUrl: "",
      serviceTab: 1,
      swiperOption: {
        autoplay: {
            delay: 2500000,
        },
        pagination: {
            el: ".swiper-pagination",
        }
      },
      ServiceSwiperOption: {
        pagination: {
            el: ".service-swiper-pagination",
            clickable :true,
        },
        initialSlide: 0,
        on: {
          paginationUpdate: ({ realIndex })=> {
            this.serviceTabIndex = realIndex
          }
        }
      },
      serviceTabIndex: 0,
      showEcoSolution: false,//显示金融方案框
      showQR: false,//显示添加咨询框
      showReserve: false,//显示预约到店看车
      showAskFee: false,//咨询
      shopView: {
        mobile: "",
        username: "",
        plantime: "",
        msg: ""
      },
      curFocused: false, //是不已收藏
      recommandList: [],
      pageTitle: "",
      carInfo: {},
      id: "",
      psn: "",
      onShareFriends: false
    }
  },
  watch: {
    pageInfo(newPageInfo){
      this.carInfo = newPageInfo.Extinfo
      const { BrowserTabTitle } = newPageInfo
      this.pageTitle = BrowserTabTitle
    },
    userInfo(newUserInfo){
      this.getIsFocusCar().then(resp=>{})
      const { user : { appid } } = newUserInfo
      const { id } = this.$route.query
      getPayInfo({appid, pageid: id }).then(resp => {
        if(resp.code === 0){
          if(resp.data.uuid && resp.data.uuid.length > 0){
            this.isPaid = true
          }
        }
      })
    }
  },
  computed: {
    pageBanners(){
        if(!this.pageInfo) return []
        if(!this.pageInfo.Extinfo) return []
        const { imgs } = this.pageInfo.Extinfo
        if(!imgs) return []
        const list = imgs.split('|')[0]
        return list ? list.split(',') : []
    },
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo",
      "rsCardInfo"
    ])
  },
  methods: {
    onVideoTap(){
      
    },
    onPlayVideo(item){
      this.showVideo = true
    },
    onShowCarImage(){
      const carImages = this.pageBanners.filter(item => !/\.mp4$/.test(item))
      wx.previewImage({
        current: carImages[0],
        urls: carImages
      })
    },
    onShowQRService(){
      wx.previewImage({
        current: 'https://assets.rurushishi.com/yq-rs-make/car/mobile/images/gx-qrcode.jpeg?x-oss-process=image/resize,h_230,m_lfit',
        urls: ['https://assets.rurushishi.com/yq-rs-make/car/mobile/images/gx-qrcode.jpeg?x-oss-process=image/resize,h_230,m_lfit']
      })
    },
    changeSwiper(index){
      this.$refs.serviceSwiper.swiper.pagination.bullets[index].click()
    },
    openPay(){
      if(this.isPaid){
        MessageBox('支付提醒', '当前车辆，已被其他车主锁定，您可以看看其它车辆！')
        return ;
      }
      MessageBox.confirm('确认支付，立马锁定当前车辆吗？').then(async() => {
        const {user : {appid, openid, nickname}} = this.userInfo
        const { BrowserTabTitle } = this.pageInfo
        const payParams = {
          appid,
          nickname,
          openid,
          //fee: 1,
          pageid: this.id,
          remark: `支付_${BrowserTabTitle}_意向金`
        }
        console.log(payParams)
        Indicator.open('初始化中...');
        const ret = await createPay(payParams)
        Indicator.close();
        if(ret.code === 0){
          wx.miniProgram.navigateTo({
            url: `/pages/pay/wxpay?query=${encodeURIComponent(JSON.stringify(ret.data))}&okurl=${encodeURIComponent(window.location.href)}`
          })
        }
      })
      //console.log(ret)
    },
    confirmReserveTime(newTime){
      //const newTime = this.planTimeValue
      console.log('newTime:', newTime)
      this.shopView.plantime = newTime.getFullYear() + 
      '-' + (newTime.getMonth() + 1).toString().padStart(2,"0") + 
      '-' + newTime.getDate().toString().padStart(2,"0") + 
      ' ' + newTime.getHours().toString().padStart(2,"0") + ':00:00'
    },
    navigateTo,
    openTimePicker(){
      this.$refs.picker.open()
    },
    resetFormData(){
        this.shopView = {
          mobile: "",
          username: "",
          plantime: "",
          msg: ""
        }
    },
    //拼装线索数据
    formatSubmitData(atype){
      const {user : {appid, openid}} = this.userInfo
      const { psn } = this.$route.query
      const { PageId, BrowserTabTitle, Extinfo } = this.pageInfo
      let formData = this.shopView
      formData.appid = appid
      formData.pageid = PageId
      formData.atype = atype
      formData.refereeopenid = openid
      formData.extinfo = {
          title: BrowserTabTitle,
          psn,
          price: Extinfo.price,
          trip: Extinfo.trip,
          power: Extinfo.power,
          regDate: Extinfo.regDate
        }
      formData.extinfo = JSON.stringify(formData.extinfo)
      return formData
    },
    //咨询
    async onConfirmAskFee(){
      const formData = this.formatSubmitData(1)
      if(!/^1\d{10}$/ig.test(formData.mobile)){
        Toast('请输入正确的手机号！')
        return ;
      }
      delete formData.plantime
      const ret = await createClue(formData)
      if(ret.data){
        MessageBox('提交成功', '我们将尽快回复您！');
        this.resetFormData()
      }else{

      }
    },
    //预约到店看车
    async onConfirmShopView(){
      const formData = this.formatSubmitData(2)
      if(formData.username.length === 0){
        Toast('请输入您的姓名！')
        return ;
      }
      if(!/^1\d{10}$/ig.test(formData.mobile)){
        Toast('请输入正确的手机号！')
        return ;
      }
      const ret = await createClue(formData)
      if(ret.data){
        MessageBox('提交成功', '我们将尽快与您取得联系！')
        this.resetFormData()
        this.showReserve = false
      }else{

      }
    },
    //获取是否收藏
    async getIsFocusCar(){
       const { user: { openid } } = this.userInfo
       const { id } = this.$route.query
       const ret = await getFavorite({openid, pageid: id })
       if(ret.data && ret.data.uuid){
         this.curFocused = true
       }else{
         this.curFocused = false
       }
    },
    //取消收藏
    async onCancelFocusCar(){
       const { user: { openid } } = this.userInfo
       const { id } = this.$route.query
       const ret = await removeFavorite({openid, pageid: id })
       if(ret.data){
         this.curFocused = false
         Toast({
            message: '已取消收藏！',
            duration: 1500
          })
       }
    },
    //创建收藏
    async onFocusCar(){
      const { user: { openid } } = this.userInfo
      const { psn } = this.$route.query
      const { PageId, BrowserTabTitle, Extinfo} = this.pageInfo
      const favData = { 
        openid,
        pageid: PageId,
        title: BrowserTabTitle,
        imgs: Extinfo.imgs.split(',')[0],
        extinfo: {
          psn,
          price: Extinfo.price,
          trip: Extinfo.trip,
          power: Extinfo.power,
          regDate: Extinfo.regDate
        }
      }
      favData.extinfo = JSON.stringify(favData.extinfo)
      const ret = await createFavorite(favData)
      if(ret.data){
        Toast({
            message: '收藏成功！',
            duration: 1500
          })
        this.curFocused = true
      }else{

      }
    }
  },
  created() {
    const metas = document.getElementsByTagName('meta')
    for(let i = 0; i<metas.length; i ++){
      //console.log(metas[i].name)
      if(metas[i].name === 'viewport'){
        const _content = metas[i].content
        metas[i].content += ',viewport-fit=cover'
        //console.log('viewport',_content)
      }  
    }
  }, 
  mounted() {
    const {id, psn} = this.$route.query
    this.id = id
    this.psn = psn
    //wxsdk.init()
  }
};
</script>

<style lang="scss" scoped>
  .car-info{
        width: 100%;
        background: #F5F5F5;
        .page-top{
            height: 5.8rem;
            .banner{
                overflow: hidden;
                .bnr-box{
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-content: center;
                    height: 3.6rem;
                    position: relative;
                    .banner_swiper{
                      position: relative;
                      width: 100%;
                      overflow: hidden;
                      z-index: 2
                    }
                    .vd-box{
                      width: 100%;
                      position: relative;
                      .circle-border{
                        position: absolute;
                        top: 1.3rem;
                        left: 3.3rem;
                        width: 1rem;
                        height: 1rem;
                        border-radius: 50%;
                        background-color: rgba(0,0,0,.23);
                        border: solid 1px #FFF;
                      }
                      .uc-bofang{
                        position: relative;
                        top: .3rem;
                        left: .3rem;
                        font-size: .45rem;
                        color:#fff;
                        z-index: 3;
                      }
                    }
                    .b-pic{
                        width: 7.6rem;
                        height: 3.6rem;
                    }
                    .bnr-loading{
                      display: flex;
                      position: absolute;
                      width: 100%;
                      justify-content: center;
                      align-items: center;
                      top: 1rem;
                      left: 0rem;
                      z-index: 1;
                    }
                }
            }
            .cartop{
              position: relative;
              z-index: 2;
              top: -.5rem;
              display: flex;
              flex-direction: column;
              background:#fff;
              padding: 0rem .25rem;
              .mk-top{
                display: flex;
                padding: .3rem 0rem .1rem 0rem;
                h1{
                  flex: 1;
                  color:#313131;
                  font-size: .3rem;
                }
                .opt{
                  width: 1rem;
                  display: flex;
                  justify-content: space-between;
                  .fav{
                    .icon-focus{
                      max-height: .3rem;
                    }
                    .focused{
                      -webkit-filter: grayscale(1); 
                      filter: gray; 
                      filter: grayscale(1); 
                    }
                  }

                  .share{
                    .icon-share{
                      max-height: .3rem;
                    }
                  }
                }
              }
              .mk-center{
                display: flex;
                justify-content: space-between;
                padding: .3rem 0rem;
                .fee{
                  color:#FF8E3B;
                  .sltt{
                    font-size: .3rem;
                  }
                  .ortt{
                    font-size: .2rem;
                  }
                  .ctline{
                    font-size: .2rem;
                    text-decoration: line-through;
                  }
                  .ct-span{
                    padding-left: .2rem;
                    color:#666;
                    font-size:.2rem;
                  }
                }
                .btn{
                  .sp{
                    color:#0D89FF;
                    border: solid 1px #0D89FF;
                    font-size: .2rem;
                    padding: .06rem .2rem;
                  }
                }
              }
              .mk-btm{
                display: flex;
                justify-content: space-between;
                border-top: solid 1px #f1f1f1;
                padding: .25rem 0rem;
                font-size: .23rem;
                .stt{
                  color: #313131;
                  .reg-tag{

                  }
                }
                .sdec{
                  display:flex;
                  align-items: center;
                  color:#888888;
                  .uc-jinru{

                  }
                }
              }
            }
        }
        .mblock{
          margin: 0rem .3rem .3rem .3rem;
          background:#fff;
          box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.06);
          border-radius: 5px;
          .mb-title{
            display: flex;
            justify-content: space-between;
            padding: .3rem 0rem .25rem 0rem;
            margin: 0rem .25rem;
            border-bottom: solid 1px #f1f1f1;
            h3{
              font-size: .26rem;
              font-weight: bold;
              color:#313131;
            }
            .sub-tt{
              display: flex;
              align-items: center;
              justify-content: flex-end;
              cursor: pointer;
              .txt{
                font-size: .23rem;
                color:#0D89FF;
                display: flex;
                align-items:center;
                .uc-jinru{
                  margin-left: .01rem;
                  color:#888;
                }
              }
            }
          }
        }
        .detect-items{
          .detects{
            padding:.15rem .25rem;
            li{
              display: flex;
              justify-content: space-between;
              padding: .13rem 0rem;
              .name{
                font-size:.23rem;
                color: #555555;
              }
              .status{
                font-size: .18rem;
                color:#55DE5F;
                background: rgba(42, 211, 54, 0.15);
                border: 1px solid rgba(42, 211, 54, .6);
                padding: .05rem .1rem;
                border-radius: 2px;
              }
            }
          }
        }
        .info-items{
          margin: 0rem .25rem;
          padding: .3rem 0rem;
          .params{
            display: flex;
            li{
              display: flex;
              flex-direction: column;
              flex: 1;
              font-size:.23rem;
              text-align: center;
              .field{
                position: relative;
                color: #888888;
                padding: .2rem 0rem;

              }
              .value{
                color:#555555;
              }
            }
          }
        }
        .service-items{
          margin: 0rem .25rem;
          .services{
            display: flex;
            justify-content: space-between;
            padding: .25rem 0rem;
            li{
              width: 1.75rem;
              background:rgba(0, 157, 254, .1);
              border-radius: 5px;
              display: flex;
              flex-direction: column;
              align-items: center;
              .iconfont{
                font-size:.6rem;
                color:#009DFE;
                padding: .3rem 0rem;
              }
              .name{
                text-align: center;
                font-size:.23rem;
                color: #009DFE;
                padding-bottom: .38rem;
              }
            }
            .active-step{
              background-color: rgba(236, 130, 57, .1);
              .iconfont{
                    color: #EC8239;
                }
                .name{
                    color: #EC8239;
                }
            }
          }
          .serv-pic-swiper{
            width: 100%;
            height:2.4rem;
            margin-bottom: .2rem;
            img.srv-pic{
              width: 6.5rem;
              height:2.4rem;
              border-radius: 5px;
            }
            .service-swiper{
              width: 100%;
              .service-swiper-pagination{
                display: none;
              }
            }
          }
          .pay-con{

            .ppic{
              position: relative;
              padding-bottom: .3rem;
              .pay-bg{
                width: 6.5rem;
                height: 3.4rem;
                border-radius: 5px;
              }
            }
          }
        }
        .car-box{
            width: 7rem;
            margin: .1rem .3rem;
            background: #FFFFFF;
            box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.06);
            h2{
                padding: .23rem;
                font-size: .26rem;
                font-weight: bold;
            }
            .ls-body{
                padding: 0rem .3rem;
                .ls-items{
                    display: flex;
                    flex-direction: column;
                    .acar{
                        display: flex;
                        padding: .2rem 0rem;
                        .img{
                            width: 2.3rem;
                            height: 1.5rem;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            .car-img{
                                width: 2.3rem;
                                height: 1.5rem;
                                border-radius: 6px;
                            }
                        }
                        .des{
                            flex: 1;
                            h3{
                                padding: .1rem .2rem;
                            }
                            .params{
                                padding: .1rem .2rem;
                                font-size: .2rem;
                                color: #888;
                                span{
                                    margin-right: .2rem;
                                }
                            }
                            .tags{
                                padding: .1rem .2rem;
                                font-size: .2rem;
                                span{
                                    margin-right: .2rem;
                                }
                                .price{
                                    color: #FF8E3B;
                                }
                                .tg1{
                                    padding: .02rem .05rem;
                                    background: #FAF3E4;
                                    color: #EA9E33;
                                }
                                .tg2{
                                    padding: .02rem .1rem;
                                    background: #E4F5EE;
                                    color: #55DE5F;
                                }
                            }
                        }
                    }
                }
            }
        }
        .quick-btns{
          position: fixed;
          left: 0rem;
          bottom: 0rem;
          width: 100%;
          background:#fff;
          padding: 0rem .25rem;
          z-index: 1;
          padding-bottom: constant(safe-area-inset-bottom);
          padding-bottom: env(safe-area-inset-bottom);
          .quick-icons{
            display: flex;
            li{
              display: flex;
              flex: 1;
              flex-direction: column;
              align-items: center;
              .icon{
                padding: .1rem 0rem;
                height: .6rem;
                display: flex;
                align-items: center;
               .qk-icon{
                 max-width: .4rem;
                 max-height: .4rem;
               } 
              }
              .name{
                color:#888888;
                padding-bottom: .15rem;
                font-size:.23rem;
              }
            }
          }
        }
        .btn-info{
          padding: .3rem 0rem;
          margin-bottom: 1rem;
          display: flex;
          justify-content: center;
          .gp-logo{
            max-height: .38rem;
          }
        }
        .mt-popup {
          width: 100%;
          min-height: 2rem;
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
          overflow: hidden;
          .popup-container {
            width: 100%;
            height: 100%;
            background-color: white;
            .title {
              display: flex;
              color: #333;
              padding: .2rem;
              .h3 {
                font-size: .263rem;
              }
            }
            .content{
              color:#333;
              padding: .13rem .2rem;
              line-height: .23rem;
              .form{
                display: flex;
                flex-direction: column;
                .row{
                  display: flex;
                  padding: .2rem 0rem;
                  .title{
                    width: 1.3rem;
                    font-size: .23rem;
                  }
                  .field{
                    flex: 1;
                    border-radius: 5px;
                    display:flex;
                    align-items: center;
                    background:#f5f5f5;
                    box-sizing:border-box;
                    padding-left: .15rem;
                    margin-right: .1rem;
                    input{
                      background: #f5f5f5;
                    }
                    .txt-area{
                      width: 100%;
                      background: transparent;
                      padding-top:.1rem;
                    }
                    .uc-jinru{
                      position: absolute;
                      right: .35rem;
                      color:#999;
                    }
                  }
                }
                ::placeholder{
                  color:#888;
                  font-size: .23rem;
                }
              }
            }
            .btn-row{
              padding:.3rem;
              text-align: center;
            }
            .mt-picker {
            }
            
          }
        }
      .mint-popup-center{
        width: 4.5rem;
        height: 4.5rem;
        
        box-sizing:border-box;
        border-radius: 20px;
        .popup-container{
          overflow: hidden;
          position: relative;
          .uc-guanbi{
            position: absolute;
            top: .35rem;
            right: .35rem;
            font-size: .35rem;
            color:#888;
          }
          .qr-box{
            width: 100%;
            margin-top: .65rem;
            text-align: center;
            img{
              width: 2.5rem;
              height: 2.5rem;
            }
          }
          .qr-desc{
            padding: .26rem .5rem;
            font-size: .26rem;
            line-height: .4rem;
            color:#888;
            text-align: center;
          }
        }
      }
      
      .btm-popup-ok{
        border: none;
        outline: none;
        padding: .2rem 1.3rem;
        font-size: .23rem;
        border-radius: 3rem;
        color:#fff;
        background: linear-gradient(135deg, #18B8F9, #0C86FF);
        box-shadow: 1px 14px 25px 0px rgba(24, 184, 249, 0.2);
      }
    }
.share_mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 35;
}

.share_mask .share_line {
  position: absolute;
  top: 0px;
  right: 0;
  z-index: 9;
  width: 275px;
}

.share_mask .share_line > span {
  width: 4px;
  height: 4px;
  border-radius: 30%;
  background-color: #fff;
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  display: inline-block;
  z-index: 8;
  -webkit-animation: sroll 3s infinite;
  animation: sroll 3s infinite;
}

.share_mask .share_line > img {
  width: 100%;
  animation: scaol 1.5s infinite;
}
@keyframes sroll {
  0% {
    transform: translate(0px, 0px);
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }

  100% {
    opacity: 0.3;
    transform: translate(180px, -200px);
  }
}

@keyframes scaol {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.05);
    opacity: 0.7;
  }

  80% {
    transform: scale(1.03);
    opacity: 0.75;
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.share_mask .txt1 {
  position: absolute;
  top: 300px;
  left: 50%;
  margin-left: -100px;
  z-index: 9;
  width: 300px;
  color: #fffdd2;
  font-size: 16px;
}
.share_mask .txt1 .txt1_span {
  font-size: 20px;
  color: #dddc68;
}
.share_mask .txt2 {
  position: absolute;
  top: 330px;
  left: 50%;
  margin-left: -100px;
  z-index: 9;
  width: 300px;
  color: #fffdd2;
  font-size: 16px;
}
.tray {
  position: absolute;
  top: 320px;
  left: 50%;
  margin-left: -170px;
  z-index: 9;
  width: 350px;
  color: #fffdd2;
  font-size: 16px;
  z-index: -1;
}
.video-player{
  position: fixed;
  top: 0rem;
  z-index: 5;
  width: 100%;
  height: 100%;
  background: #383838;
  .v-container{
    height: 100%;
    display: flex;
    justify-content: center;    
    align-items: center;
  }
}
</style>
<style>
	.mint-indicator-wrapper {
		z-index: 1000 !important;
	}
 
	.mint-indicator-mask {
		z-index: 1000 !important;
	}
</style>